import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React from 'react';
import { ChevronFirst, ChevronLast, ChevronLeft, ChevronRight, Info } from 'lucide-react';
import styles from '../ReportCard.module.scss';

/**
 * Компонент пагинации (первая / назад / вперёд / последняя).
 */
const Pagination = ({ page, setPage, count, hasNext, hasPrev, pageSize = 10, shownCount, style, onLegend, loading = false }) => {
  useInterfaceLanguage();
  const totalPages = Math.ceil(count / pageSize);

  return (
    <div className={styles.paginationContainer} style={style} role="navigation" aria-label={tr("Страницы списка")} aria-busy={loading}>
      <div className={styles.paginationButtons}>
        <button
          onClick={() => setPage(1)}
          disabled={loading || page === 1}
          title={tr("Первая страница")}
          aria-label={tr("Первая страница")}
          className={styles.paginationBtnFirst}
        >
          <ChevronFirst size={17} /><span>{tr("Первая")}</span>
        </button>
        <button
          onClick={() => setPage(p => Math.max(1, p - 1))}
          disabled={loading || !hasPrev || page === 1}
          aria-label={tr("Предыдущая страница")}
          className={styles.paginationBtnPrev}
        >
          <ChevronLeft size={17} /><span className={styles.paginationButtonLabel}>{tr("Назад")}</span>
        </button>
        <span className={styles.paginationText}>
          <span className={styles.paginationPageLabel}>{tr("Страница ")}</span>{tr(page)} {totalPages > 0 ? tr("из {{value0}}", { value0: totalPages }) : ''}
        </span>
        <button
          onClick={() => setPage(p => p + 1)}
          disabled={loading || !hasNext}
          aria-label={tr("Следующая страница")}
          className={styles.paginationBtnNext}
        >
          <span className={styles.paginationButtonLabel}>{tr("Вперёд")}</span><ChevronRight size={17} />
        </button>
        <button
          onClick={() => { if (totalPages > 0) setPage(totalPages); }}
          disabled={loading || !hasNext || page === totalPages}
          title={tr("Последняя страница")}
          aria-label={tr("Последняя страница")}
          className={styles.paginationBtnLast}
        >
          <span>{tr("Последняя")}</span><ChevronLast size={17} />
        </button>
      </div>
      {tr(onLegend && (
        <button
          onClick={onLegend}
          className={styles.paginationBtnLegend}
          title={tr("Описание цветов")}
          aria-label={tr("Информация о цветах таблицы")}
        >
          <Info size={17} />
          <span className={styles.paginationBtnLegendLabel}>{tr("Информация")}</span>
        </button>
      ))}
      <div className={styles.paginationInfo}>{tr("Показано ")}{tr(shownCount)}{tr(" из ")}{tr(count)}{tr(" записей")}</div>
    </div>
  );
};

export default React.memo(Pagination);
